var map = {
	"./allizLogo.svg": "/ZOR",
	"./aplicativeiLogo.svg": "6WBT",
	"./appqdLogo.svg": "NJUo",
	"./arquibaLogo.svg": "1X5I",
	"./baratoLogo.svg": "1tYA",
	"./bewalletLogo.svg": "jWS3",
	"./btgPactualLogo.svg": "/ebB",
	"./c3cLogo.svg": "MCFM",
	"./decodeLogo.svg": "K9fV",
	"./dr.onLogo.svg": "F29G",
	"./ferreriLogo.svg": "z2xh",
	"./flyfastLogo.svg": "ygv5",
	"./galapagosLogo.svg": "TKCP",
	"./gocaseLogo.svg": "q9qU",
	"./lgLogo.svg": "uKip",
	"./nbLogo.svg": "5ofe",
	"./portalsaboresLogo.svg": "Fpg4",
	"./privaliaLogo.svg": "KFTP",
	"./togarantidoLogo.svg": "p0o+",
	"./urbisLogo.svg": "cf0E",
	"./zanchettaLogo.svg": "qjvn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8Oex";